module.exports = __webpack_public_path__ + "./img/loader.867d359de20694436d479437bd8ffcdb.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/loader.gif
// module id = ./public/img/loader.gif
// module chunks = 0